/**
 * Component: basicDetailsReducer.js
 * Description: This reducer manages the state related to basic details of the asset.
 */

const initialState = {   
       "hospitalName":"",
       "hospitalid":"",
      "facilityid": "",
      "serviceId": "",
      "workordercategory": null,
      "fromDate":  "", 
      "toDate":  "", 
      "groupBy": "",
      "workOrderType": null,
      "scheduleWorkorderReportLevelOneLists": [
        {
         
        }
      ]
    };
  
  const workorderReportsFilter = (state = initialState, action) => {
   

    switch (action.type) {
      case 'UPDATE_WORKORDER_REPORTS_DETAILS':
        return {
          ...state,
          ...action.payload,
        };
      case 'CLEAR_WORKORDER_REPORTS_DETAILS':
        return initialState; // Reset to initial state
      default:
        return state;
    }
  };
  
  export default workorderReportsFilter;
  